import { MailboxFormComponent } from "@/components/forms/mailbox-form";
import { formTypeSchema } from "@eiralab/backend/schemas";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const formSearchSchema = z.object({
  formType: formTypeSchema,
  origin: z.enum(["company", "my"]).optional(),
});

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/f/$formId/",
)({
  component: RouteComponent,
  validateSearch: zodValidator(formSearchSchema),
});

function RouteComponent() {
  const { companyId, formId } = Route.useParams();
  const { formType, origin } = Route.useSearch();

  if (formType === "mailbox") {
    return (
      <MailboxFormComponent
        companyId={companyId}
        teamId=""
        formId={formId}
        origin={origin}
      />
    );
  }

  return null;
}
